import React from "react";
import FontIcon from "react-md/lib/FontIcons";
import Link from "gatsby-link";

function GetNavList(config) {
  const NavList = [
    {
      primaryText: "الرئيسية",
      leftIcon: <FontIcon iconClassName="fa fa-home"/>,
      component: Link,
      to: "/"
    },
    {
      divider: true
    },
    {
      primaryText: "المقالات",
      leftIcon: <FontIcon iconClassName="fa fa-book"/>,
      component: Link,
      to: "/articles"
    },{
      divider: true
    },
    {
      primaryText: "المشاريع",
      leftIcon: <FontIcon iconClassName="fa fa-rocket"/>,
      component: Link,
      to: "/projects"
    },{
      divider: true
    },
  ];

  if (config.userLinks) {
    config.userLinks.forEach(link => {
      NavList.push({
        primaryText: link.label,
        leftIcon: <FontIcon forceSize iconClassName={link.iconClassName} />,
        component: "a",
        href: link.url
      });
    });
  }

  NavList.push({ divider: true });

  // NavList.push({
  //   primaryText: "عني",
  //   leftIcon: <FontIcon iconClassName="fa fa-user"/>,
  //   component: Link,
  //   to: "/about/"
  // });
  return NavList;
}
export default GetNavList;



// WEBPACK FOOTER //
// ./src/components/Navigation/NavList.jsx